/// <summary>
/// Данное перечисление создано в рамках задачи TES-8902, так как в рамках задачи TES-8640 был реализован
/// схожий функционал в методе AllowEditESUDDocs(ICardUIExtensionContext context, ISession session)
/// отличие лишь в табличных частях с которыми мы работаем, соотвественно, чтобы не плодить кучу схожих методов
/// решил добавить перечисление, где 3-им аргументов будет прокидываться enum секции, как опознавательный знак
/// P.S. возможно пригодится для других задач
/// </summary>
export enum DocumentSections {
    ContractArticleIdp = 1,
    ArContractPartnersTable = 2
}